import styled from 'styled-components';

export const StyledSidebar = styled.div`
  direction: ltr;
  position: absolute;
  top: 45px;
  left: 32px;
  .sidebar-container {
    width: 160px;
    height: min-content;
    display: none;
    gap: 43px;
    position: fixed;
  }
  .side-freesens-logo {
    width: 146px;
    height: 45px;
    margin-right: auto;
  }
  ul {
    background: #ffffff;
    width: ${({ isExpanded }) => (isExpanded ? '100%' : '60px')};
    overflow: hidden;
    display: grid;
    border-radius: 16px;
    border: 1px solid #ebebeb;
    transition: width 0.3s ease;
    padding: 23px 0;
    display: grid;
    gap: 8px;
  }
  li {
    display: flex;
    width: 100%;
    height: 50px;
    list-style: none;
  }
  .li-divider {
    width: 100%;
    height: 1px;
    background: #d8d8d8;
    margin-top: 8px;
  }
  .li-isActive {
    background: linear-gradient(
      296.02deg,
      rgba(117, 60, 190, 0.2) 0%,
      rgba(60, 192, 195, 0.2) 100%
    );
    color: #753cbe !important;
  }
  .li-content img {
    padding-bottom: 7px;
  }
  .li-content span {
    font-family: 'dana-bold';
    visibility: ${({ isExpanded }) => (!isExpanded ? 'hidden' : 'visible')};
    width: max-content;
  }
  .li-content {
    width: 100%;
    display: flex;
    gap: 14px;
    align-items: center;
    padding: 0 18px;
    color: #707070;
    font-size: 16px;
    text-transform: capitalize;
  }
  .li-border {
    width: ${({ isExpanded }) => (isExpanded ? '5px' : '')};
    border-radius: 100px;
    height: 100%;
    border-radius: 5px 0 0 5px;
    background: linear-gradient(
      296.02deg,
      rgba(117, 60, 190, 0.8) 0%,
      rgba(60, 192, 195, 0.8) 100%
    );
  }
  li:hover {
    .li-content {
      color: #753cbe !important;
    }
    background: linear-gradient(
      296.02deg,
      rgba(117, 60, 190, 0.2) 0%,
      rgba(60, 192, 195, 0.2) 100%
    );
  }

  @media screen and (min-width: 1024px) {
    .sidebar-container {
      display: grid;
    }
  }
`;
